import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./about.styles.css";
import Profile from "../../assets/img/profile/profile-pic.png";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

const About = () => {
  return (
    <div>
      <div className="about">
        <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2">
                <Image
                  className="profile justify-content-end"
                  alt="profile"
                  src={Profile}
                  thumbnail
                  fluid
                />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className=" align-items-start p-2 my-details rounded">
                <div>
                  <p>
                    Hi there! I'm <strong>Shivanand Vishwakarma</strong>, a passionate{" "}
                    <strong>Full Stack MERN Developer</strong> with{" "}
                    <strong>3+ years of experience</strong> building scalable, high-performance SaaS
                    products.
                  </p>
                  <p>
                    I specialize in building end-to-end web applications using{" "}
                    <strong>
                      React.js, Next.js, Redux Toolkit, TypeScript, Node.js, Express.js, MongoDB,
                      and Redis
                    </strong>
                    . I enjoy creating intuitive, responsive user interfaces while designing robust
                    backend systems that are scalable, secure, and production-ready.
                  </p>
                  <p>
                    Over the past 3+ years, I've contributed to AI-powered interview platforms,
                    enterprise SaaS applications, and IoT-enabled products. From developing reusable
                    React components and optimizing frontend performance to designing REST APIs,
                    real-time systems, scalable backend architectures, and CI/CD pipelines for
                    reliable deployments, I enjoy solving complex engineering challenges that create
                    measurable business impact.
                  </p>
                  <p>
                    I'm passionate about clean code, performance optimization, system design, and
                    continuous learning. Outside of work, I enjoy building personal projects,
                    exploring new technologies, and following cricket.
                  </p>
                </div>
                <Col className="d-flex justify-content-center flex-wrap">
                  <div>
                    <a href="#contact">
                      <Button className="m-2" variant="outline-primary">
                        Let's talk
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://drive.google.com/file/d/1KyFFw9CmiF4BC7F5EVqHN_WQpkmMX-h8/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="m-2" variant="outline-success">
                        My Resume
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/Shiva7781"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="m-2" variant="outline-dark">
                        GitHub
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.linkedin.com/in/shivanand-vishwakarma/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="m-2" variant="outline-info">
                        LinkedIn
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
